import PropTypes from 'prop-types'
import React, {useState} from 'react'
import i18n from 'i18next'
import MonthPicker from '#components/m/MonthPicker/MonthPicker'
import {endOfMonth, startOfMonth, setMonth, setYear, isAfter, isBefore, getMonth, getYear} from 'ag-common/facades'
import _ from 'lodash'

function MonthRangePicker({startDate, endDate, setStartDate, setEndDate, isMonthOnly}) {
  const [startFlyoutVisible, setStartFlyoutVisible] = useState(false)
  const [endFlyoutVisible, setEndFlyoutVisible] = useState(false)

  const onSelectStartDate = (month, year, closeFlyout) => {
    let nextStartDate = createDateFrom(month, year)
    nextStartDate = startOfMonth(nextStartDate)
    setStartDate(nextStartDate)
    if (isAfter(nextStartDate, endDate)) {
      setEndDate(endOfMonth(nextStartDate))
    }
    if (closeFlyout) {
      setStartFlyoutVisible(false)
    }
  }

  const onSelectEndDate = (month, year, closeFlyout) => {
    let nextEndDate = createDateFrom(month, year)
    nextEndDate = endOfMonth(nextEndDate)
    setEndDate(nextEndDate)
    if (isBefore(nextEndDate, startDate)) {
      setStartDate(startOfMonth(nextEndDate))
    }
    if (closeFlyout) {
      setEndFlyoutVisible(false)
    }
  }

  const createDateFrom = (month, year) => {
    let date = new Date()
    date = setMonth(date, month)
    return setYear(date, year)
  }

  const onStartFlyoutVisibilityChanged = visible => {
    setStartFlyoutVisible(visible)
    setEndFlyoutVisible(false)
  }

  const onEndFlyoutVisibilityChanged = visible => {
    setEndFlyoutVisible(visible)
    setStartFlyoutVisible(false)
  }

  const calculateSelectedMonthsForStart = () => {
    let selectedMonths = [getMonth(startDate)]
    if (getYear(startDate) === getYear(endDate)) {
      selectedMonths.push(getMonth(endDate))
    }
    return selectedMonths
  }

  const calculateSelectedMonthsForEnd = () => {
    let selectedMonths = [getMonth(endDate)]
    if (getYear(startDate) === getYear(endDate)) {
      selectedMonths.push(getMonth(startDate))
    }
    return selectedMonths
  }

  const calculateMarkedMonthsForStart = () => {
    return _.range(getMonth(startDate), getYear(startDate) === getYear(endDate) ? getMonth(endDate) : 12)
  }

  const calculateMarkedMonthsForEnd = () => {
    return _.range(getYear(startDate) === getYear(endDate) ? getMonth(startDate) : 0, getMonth(endDate))
  }

  function renderMonthPicker(
    onSelectDate,
    date,
    flyoutVisible,
    onFlyoutVisibilityChanged,
    selectedMonths,
    markedMonths,
  ) {
    return (
      <MonthPicker
        onSelectDate={onSelectDate}
        selectedDate={date}
        flyoutVisible={flyoutVisible}
        onFlyoutVisibilityChanged={onFlyoutVisibilityChanged}
        selectedMonths={selectedMonths}
        markedMonths={markedMonths}
        isMonthOnly={isMonthOnly}
      />
    )
  }

  return (
    <div className="monthRangePicker">
      <div className="monthRangePicker__from">
        <span>{i18n.t('misc_from')}</span>
        {renderMonthPicker(
          onSelectStartDate,
          startDate,
          startFlyoutVisible,
          onStartFlyoutVisibilityChanged,
          calculateSelectedMonthsForStart(),
          calculateMarkedMonthsForStart(),
        )}
      </div>
      <div className="monthRangePicker__to">
        <span>{i18n.t('misc_to')}</span>
        {renderMonthPicker(
          onSelectEndDate,
          endDate,
          endFlyoutVisible,
          onEndFlyoutVisibilityChanged,
          calculateSelectedMonthsForEnd(),
          calculateMarkedMonthsForEnd(),
        )}
      </div>
    </div>
  )
}

MonthRangePicker.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
  isMonthOnly: PropTypes.bool,
}

export default MonthRangePicker
